import axios from './api'
const teamServer = {
    getOrgUserPageList(params) {
        return axios.post(`/org/orgUser/pageList`, params).then((res) => {
            return res.data
        })
	  },

    getTeamPageList(params) {
        return axios.post(`/org/team/pageList`, params).then((res) => {
            return res.data
        })
    },

    addAccount(params) {
        return axios.post(`/org/orgUser/saveOrUpdate`, params).then((res) => {
            return res.data
        })
    },

    getAccountDetails(params) {
        return axios.get(`/org/orgUser/load`, {params: params}).then((res) => {
            return res.data
        })
    },    

    getTeamDetails(params) {
        return axios.get(`/org/team/load`, {params: params}).then((res) => {
            return res.data
        })
    },

    addTeam(params) {
        return axios.post(`/org/team/saveOrUpdate`, params).then((res) => {
            return res.data
        })
    },

    switchAutoAccept(params) {
        return axios.get(`/org/orgUser/edit/switch/` + params.id).then((res) => {
            return res.data
        })
    },

    switchTeamAutoAccept(params) {
        return axios.get(`/org/team/edit/switch/` + params.id).then((res) => {
            return res.data
        })
    },

    switchAccountStatus(params) {
        return axios.get(`/org/orgUser/edit/status/` + params.id).then((res) => {
            return res.data
        })
    },

    switchTeamStatus(params) {
        return axios.get(`/org/team/edit/status/` + params.id).then((res) => {
            return res.data
        })
    },
}
export default teamServer


// WEBPACK FOOTER //
// ./src/api/team.js